const getRandomCode = (length = 8) => {
    if (length > 0) {
        var data = [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "n",
            "o",
            "p",
            "q",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
        ];
        var nums = "";
        for (var i = 0; i < length; i++) {
            var r = parseInt(Math.random() * 61);
            nums += data[r];
        }
        return "DD-" + nums + dateFormat(new Date())
        
    }
}
const dateFormat = (date) => {
    const opt = {
        "Y": date.getFullYear().toString(),        // 年
        "m": (date.getMonth() + 1).toString(),     // 月
        "d": date.getDate().toString(),            // 日
        "H": date.getHours().toString(),           // 时
        "M": date.getMinutes().toString(),         // 分
        "s": date.getSeconds().toString()          // 秒
    };
    if (Number(opt.m) < 10) {
        opt.m = '0' + opt.m.toString();
    }
    return opt.Y + opt.m + opt.d + opt.H + opt.M + opt.s
}

export{
    getRandomCode,
    dateFormat
}


// WEBPACK FOOTER //
// ./src/api/order.js